import type * as hast from 'hast';

import { createCustomBlockProperties } from '../../../utils';

/**
 * Create a custom block with a given block name, properties, and children.
 */
export function createCustomBlock(
    blockName: string,
    properties: object,
    children: Array<hast.Element | hast.Text>
): hast.Element {
    return createCustomNode('div', blockName, properties, children);
}

/**
 * Create a custom inline with a given name, properties, and children.
 */
export function createCustomInline(
    inlineName: string,
    properties: object,
    children: Array<hast.Element | hast.Text>
): hast.Element {
    return createCustomNode('span', inlineName, properties, children);
}

/**
 * Create a custom node with a given name, properties, and children.
 */
function createCustomNode(
    tagName: 'div' | 'span',
    name: string,
    properties: object,
    children: Array<hast.Element | hast.Text>
): hast.Element {
    return {
        type: 'element',
        tagName,
        properties: {
            [tagName === 'div' ? 'dataGbCustomBlock' : 'dataGbCustomInline']: true,
            dataTag: name,
            ...createCustomBlockProperties(properties),
        },
        children,
    };
}
